import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import * as api from "../../services/api";
import "./AdminLogin.css";

const ADMIN_EMAILS = [
  'jtahir21@gmail.com',
  'avrnhhofficial@gmail.com',
  'avrnhh@gmail.com'
];

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    // Check if email is in admin list
    const normalizedEmail = email.toLowerCase().trim();
    if (!ADMIN_EMAILS.includes(normalizedEmail)) {
      setError("Access denied. This email is not authorized for admin access.");
      return;
    }

    setLoading(true);
    try {
      const data = await api.login({ email: normalizedEmail, password });
      if (data.token && data.user) {
        // Verify user has admin role
        if (data.user.role !== 'admin') {
          setError("Your account does not have admin privileges. Please contact support.");
          setLoading(false);
          return;
        }
        login(data.token, data.user);
        navigate('/admin/dashboard');
      } else {
        setError(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Admin login error:", error);
      setError(error.response?.data?.message || "Unable to login. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>Admin Panel</h1>
          <p>AVRNHH E-commerce Management</p>
        </div>

        <form onSubmit={handleLogin} className="admin-login-form">
          {error && <div className="admin-error-message">{error}</div>}
          
          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login to Admin Panel"}
          </button>
        </form>

        <div className="admin-login-footer">
          <button 
            onClick={() => navigate('/')}
            className="back-to-site-btn"
          >
            ← Back to Site
          </button>
        </div>
      </div>
    </div>
  );
}

